import { Box, Typography } from "@mui/material";
import { Zar } from "../Logic/commonLogic";

interface Props {
  amount: number;
  label: string;
}
export default function DisplayMoney({ amount, label }: Props) {
  const displayAmount = isNaN(Number(amount)) ? 0 : Number(amount);

  return (
    <>
      <Box
        component="span"
        sx={{
          fontWeight: "200",
          fontSize: 12,
        }}
      >
        {label}
      </Box>
      <Typography
        variant="h5"
        component="h2"
        sx={{ fontWeight: "800", color: "#506e18", mb: 2 }}
      >
        {Zar.format(displayAmount)}
      </Typography>
    </>
  );
}
